import { render } from "./VWallet.vue?vue&type=template&id=650faba8"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VWallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "650faba8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('650faba8', __exports__)) {
    api.reload('650faba8', __exports__)
  }
  
  module.hot.accept("./VWallet.vue?vue&type=template&id=650faba8", () => {
    api.rerender('650faba8', render)
  })

}


export default __exports__